module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"avgRating":"Based on {count} reviews.","writeReview":"Write a review"},"ar":{"avgRating":"متوسط التقيمات من اصل {count} مراجعه","writeReview":"اكتب مراجعه"}}')
  delete Component.options._Ctor
}
